export type BridgeWarAssetsConfig = {
    avatarsFolder: string;
    backgroundsFolder: string;
    colors: Record<BridgeWarAvatarName, string>;
    domain: string;
    figurineFileName: string;
    headFileName: string;
    iconsFolder: string;
    logosFolder: string;
    lvls: number;
};

export enum BridgeWarAvatarName {
    airgenasi = 'airgenasi',
    dragon = 'dragon',
    lycan = 'lycan',
    orc = 'orc',
    phoenix = 'phoenix',
    wizard = 'wizard',
}

const config: BridgeWarAssetsConfig = {
    avatarsFolder: 'avatars',
    backgroundsFolder: 'backgrounds',
    colors: {
        [BridgeWarAvatarName.airgenasi]: '#7eb6e3',
        [BridgeWarAvatarName.dragon]: '#8B83BB',
        [BridgeWarAvatarName.lycan]: '#f69432',
        [BridgeWarAvatarName.orc]: '#8ec63f',
        [BridgeWarAvatarName.phoenix]: '#ff7060',
        [BridgeWarAvatarName.wizard]: '#c59b6e',
    },
    domain: 'https://assets.bridgebattle.com',
    figurineFileName: 'figurine.svg',
    headFileName: 'head.svg',
    iconsFolder: 'icons',
    logosFolder: 'wars-logos',
    lvls: 1,
};

export default config;
